import { useEffect, useRef } from 'react'

import { getPopupLayerContainer } from '@/components/new/ui/popup-layer'

export const PortalHost = ({ id }: { id: string }) => {
    const portalRef = useRef<HTMLElement | null>(null)
    const createdRef = useRef(false)

    if (!portalRef.current && typeof document !== 'undefined') {
        const existingPortal = document.getElementById(id)

        if (existingPortal instanceof HTMLElement) {
            portalRef.current = existingPortal
        } else {
            const portalElement = document.createElement('div')
            portalElement.id = id
            portalElement.className = 'milkdown rich-text-editor-portal-host'
            ;(getPopupLayerContainer() ?? document.body).appendChild(portalElement)

            portalRef.current = portalElement
            createdRef.current = true
        }
    }

    useEffect(() => {
        return () => {
            if (createdRef.current) {
                portalRef.current?.remove()
                portalRef.current = null
            }
        }
    }, [])

    return null
}
